import { Authority, AuthorityHistory, AuthorityWithConfig } from '../interfaces';
import { HttpService } from './http.service';
import { Config } from '../config';

export abstract class AuthorityService {
  public static getAllAuthorities = (): Promise<AuthorityWithConfig[]> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities`, {
      method: 'GET',
    }).then((res) => {
      return res;
    });
  };

  public static getFleetAuthorities = (fleetUuid: string): Promise<Authority[]> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/${fleetUuid}/authorities`, {
      method: 'GET',
    }).then((res) => {
      return res || [];
    });
  };

  public static getAuthority = (authorityUuid: string): Promise<AuthorityWithConfig> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}`, {
      method: 'GET',
    }).then((res) => {
      return res;
    });
  };

  public static createAuthority = (body: Partial<AuthorityWithConfig>): Promise<AuthorityWithConfig> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities`, {
      method: 'POST',
      body: JSON.stringify(body),
    }).then((res) => res);
  };

  public static updateAuthority = (
    authorityUuid: string,
    body: Partial<AuthorityWithConfig>,
  ): Promise<AuthorityWithConfig> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }).then((res) => res);
  };

  public static getAuthorityBoundary = (authorityUuid: string): Promise<any> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}/boundary`, {
      method: 'GET',
    });
  };

  public static updateAuthorityBoundary = (authorityUuid: string, body: any): Promise<any> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}/boundary`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  };

  public static getHistory = (authorityUuid: string): Promise<AuthorityHistory[]> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}/activity`, {
      method: 'GET',
    }).then((res) => res);
  };

  public static getFullAuthorityData = (authorityUuid: string): Promise<AuthorityWithConfig> => {
    return HttpService.fetchAuthorized(`${Config.API}/fleets/authorities/${authorityUuid}`, {
      cache: 'no-store',
    }).then((res) => res);
  };
}
